import { connect } from 'react-redux'

import { getSales } from 'selectors'

import CartRussiaRedesign from './CartRussiaRedesign'

const mapStateToProps = state => ({
  sales: getSales(state),
})

export default connect(mapStateToProps)(CartRussiaRedesign)
